import { observer } from 'mobx-react';
import getStore from '../store/store';
import * as React from 'react';
import {
    DetailsList,
    Selection,
    SelectionMode,
} from 'office-ui-fabric-react/lib/components/DetailsList';
import { formatUserDateTime } from 'owa-datetime';
import { Inspector } from 'react-inspector';
import updateSelectedServiceCallIndex from '../mutators/updateSelectedServiceCallIndex';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

let styles = require('./FormsDiagnosticsPanel.scss');

@observer
export default class FormsDiagnosticsPanel extends React.Component<any, any> {
    private selection: Selection;

    constructor(props: any) {
        super(props);
        this.selection = new Selection({
            selectionMode: SelectionMode.multiple,
            onSelectionChanged: () => {
                if (this.selection.getSelectedCount() == 1) {
                    updateSelectedServiceCallIndex(Number(this.selection.getSelection()[0].key));
                }
            },
        });
    }

    render() {
        const { serviceCalls, selectedServiceCallIndex } = getStore();
        const calls = serviceCalls
            .map((serviceCall, index) => {
                return {
                    Action: serviceCall.action,
                    Status: serviceCall.status,
                    Start: formatUserDateTime(serviceCall.start),
                    key: index,
                };
            })
            .reverse();

        return (
            <div>
                <DefaultButton onClick={this.copyToClipboard} className={styles.button}>
                    {'Copy selected rows to clipboard'}
                </DefaultButton>
                <div className={styles.container}>
                    <div className={styles.table}>
                        <DetailsList
                            items={calls}
                            selection={this.selection}
                            selectionMode={SelectionMode.multiple}
                        />
                    </div>
                    {selectedServiceCallIndex != -1 && (
                        <div className={styles.rightPanel}>
                            {this.renderObject(
                                serviceCalls[selectedServiceCallIndex].response,
                                'Response',
                                serviceCalls[selectedServiceCallIndex].action
                            )}
                            {serviceCalls[selectedServiceCallIndex].request &&
                                this.renderObject(
                                    serviceCalls[selectedServiceCallIndex].request,
                                    'Request',
                                    serviceCalls[selectedServiceCallIndex].action
                                )}
                            {serviceCalls[selectedServiceCallIndex].headers &&
                                this.renderObject(
                                    serviceCalls[selectedServiceCallIndex].headers,
                                    'Headers',
                                    serviceCalls[selectedServiceCallIndex].action
                                )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private copyToClipboard = () => {
        const fragment = this.getHtmlFragment();

        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/html', fragment);
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
    };

    private getHtmlFragment = (): string => {
        const singleCell = (cellType, cellString): string =>
            `<${cellType} style='border: 1px solid white;vertical-align: top;padding: 1.45pt .05in;'>${cellString}</${cellType}>`;
        const singleRow = (style: string, cells: string[]) => {
            let cellsAsString = '';
            cells.forEach(cell => (cellsAsString = cellsAsString.concat(cell + '\n')));
            return `<tr style=${style}>${cellsAsString}</tr>`;
        };

        const headContent = singleRow('background-color: #106EBE;color: white;', [
            singleCell('th', 'Action'),
            singleCell('th', 'Status'),
            singleCell('th', 'Start'),
            singleCell('th', 'Response'),
            singleCell('th', 'Request'),
            singleCell('th', 'Header'),
        ]);

        const getObjectString = obj => (obj ? JSON.stringify(obj).replace(/["]+/g, "'") : '');

        let bodyContent = '';
        const { serviceCalls } = getStore();
        const displayedServiceCalls = serviceCalls.reverse(); // We reverse the list in the view, so we should reverse the serviceCalls collection too. Otherwise, the indexes don't match up
        this.selection
            .getSelectedIndices()
            .forEach(
                index =>
                    (bodyContent = bodyContent.concat(
                        singleRow('background-color: #FFFFFF', [
                            singleCell('td', displayedServiceCalls[index].action),
                            singleCell('td', displayedServiceCalls[index].status),
                            singleCell('td', displayedServiceCalls[index].start),
                            singleCell(
                                'td',
                                getObjectString(displayedServiceCalls[index].response)
                            ),
                            singleCell('td', getObjectString(displayedServiceCalls[index].request)),
                            singleCell('td', getObjectString(displayedServiceCalls[index].headers)),
                        ]) + '\n'
                    ))
            );

        let tab = `<thead style='background-color: #106EBE;color: white;'>${headContent}</thead><tbody>${bodyContent}</tbody>`;
        let ret = `<table cellpadding='0' cellspacing='0' style='font-family: Calibri, sans-serif;font-size: 11pt;border-collapse: collapse;'>${tab}</table>`;
        return ret;
    };

    private renderObject = (object: Object, title: string, action) => {
        return (
            <>
                <Label>{title}</Label>
                <Inspector data={object} expandLevel={this.getExpansionLevel(action)} />
            </>
        );
    };

    private getExpansionLevel = (action: string) => {
        switch (action) {
            case 'GetUserAvailabilityInternal':
                return 3;
        }
        return 6;
    };
}

export const renderPanel = () => <FormsDiagnosticsPanel />;
